import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ENewReviewModalStep } from '../../types/newReview';

export enum EStepActionTypes {
  Set = 'NEW_REVIEW/STEP/SET',
}

export type TSetStep = ITypedReduxAction<EStepActionTypes.Set, ENewReviewModalStep>;

export type TNewReviewFormStepActions = TSetStep;

/**
 * Redux action, который вызывает устанавливает шаг формы
 */
export const setNewReviewFormStep: (step: ENewReviewModalStep) => TSetStep = actionGenerator<
  EStepActionTypes.Set,
  ENewReviewModalStep
>(EStepActionTypes.Set);
